'use strict';
(function($){
	/*
	 * Vetology.FlipBook widget
	 *
	 * @description This is the main Vetology FlipBook widget that needs a description right here
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.FlipBook',
		{
			"options": {
			},
			/*
			 * Vetology.o.options._init
			 *
			 * @description	Initializes the Vetology.FlipBook
			 *
			 * @return NULL
			 *
			 */
			_init: function(){
				var o = this;
				o.options = window.flibook_data;
				o.options.graph = {};
				$.each(o.options.lab, function(t, lab){
					$.each(lab.results, function(i, r){
						if(typeof o.options.graph[r.name] === "undefined"){
							o.options.graph[r.name] = {
								high: r.high,
								low: r.low,
								unit: r.unit,
								length: 0,
								values: {}
							};
						}
						o.options.graph[r.name].length ++;
						o.options.graph[r.name].values[r.date] = r.result;
					});
					$.each(lab.resultsGraphed, function(i, r){
						if(typeof o.options.graph[r.name] === "undefined"){
							o.options.graph[r.name] = {
								high: 100,
								low: 0,
								unit: r.unit,
								length: 0,
								values: {}
							};
						}
						o.options.graph[r.name].length ++;
						o.options.graph[r.name].values[r.date] = r.result;
					});
				});
				o.options.ids = {};
				o.options.lab_descriptions = {};
				o.options.def = {};
				o.options.pages = 1;
				o.options.bookMeta = {};
				o._setBookMeta();
				o._setBookSize();
				o._setBookSections();
				o._initEvents();
				o._initCharts();
				o._loadHTML();
				o._loadBook();
                o.onSendPdfClick = o.onSendPdfClick.bind(o);
                o.sendPDF = o.sendPDF.bind(o);
                const sendPdfBtn = document.querySelector('#send-pdf-btn');
                const sendPdfLink = document.querySelector('ul.sidebar-menu a.vetology-send-pdf');
                sendPdfLink.addEventListener('click', o.onSendPdfClick);
				sendPdfBtn.addEventListener('click', o.sendPDF);
				const customEvent = new CustomEvent('flipbook-loaded', { detail: { caseId: o.options.case_id } });	
				document.dispatchEvent(customEvent);
                const addLogoElem = document.querySelector('#add-clinic-logo a');
                if (addLogoElem) {
                    this.onAddClinicLogo = this.onAddClinicLogo.bind(this);
                    addLogoElem.addEventListener('click', this.onAddClinicLogo);
                }
            },
			_setBookMeta: function(){
				var o = this;
				var g = o.options.guarantor;
				o.options.bookMeta.owner = {};
				if(g.name.length > 0 || g.cell_phone.length > 0 || g.home_phone.length > 0 || g.work_phone.length > 0 || g.email.length > 0){
					var footerText =  "";
					footerText += g.name.length > 0 ? g.name + " " : "";
					o.options.bookMeta.owner.name = footerText;
					o.options.bookMeta.owner.phones = [];
					o.options.bookMeta.owner.work_phones = [];
					o.options.bookMeta.owner.cells = [];
					o.options.bookMeta.owner.emails = [];
					$.each([g.home_phone], function(i, p){
						if(p.length > 0){
							o.options.bookMeta.owner.phones.push(p);
						}
					});
					$.each([g.work_phone], function(i, p){
						if(p.length > 0){
							o.options.bookMeta.owner.work_phones.push(p);
						}
					});
					$.each([g.cell_phone], function(i, p){
						if(p.length > 0){
							o.options.bookMeta.owner.cells.push(p);
						}
					});
					$.each([g.email], function(i, p){
						if(p.length > 0){
							o.options.bookMeta.owner.emails.push('<a href="mailto:' + p + '">' + p + '</a>');
						}
					});
				}
				o.options.bookMeta.clinic = {};
				var footer = [];
				var facility = o.options.facility;
				o.options.bookMeta.clinic.type = facility.is_specialty ? "Hosp" : "rDVM";
				o.options.bookMeta.clinic.name = facility.name;
				o.options.bookMeta.clinic.address = facility.address + ", " + facility.city + ", " + facility.state + ", " + facility.zip;
				o.options.bookMeta.clinic.phone = facility.phone;
				o.options.bookMeta.clinic.email = facility.email;
				o.options.bookMeta.clinic.fax = facility.fax;
				o.options.bookMeta.patient = {};
				o.options.bookMeta.patient.name = o.options.patient.name;
				o.options.bookMeta.patient.breed = o.options.patient.breed;
                o.options.bookMeta.patient.species = o.options.patient.Species;
				o.options.bookMeta.patient.sex = o.options.patient.sex;
                o.options.bookMeta.patient.weight = o.options.patient.latestWeight;
				o.options.bookMeta.patient.birth = o.options.patient.birth;
                o.options.bookMeta.patient.patientAdditional = o.options.patient.patientAdditional;
				var m = moment();
				document.title = o.options.bookMeta.patient.name + ' - Vetology Flipbook - @' + m.format('MMMM Do YYYY');
			},
			_setBookSize: function(){
				var o = this;
				var height_diff = $(".main-footer").height() + $(".navbar-static-top").height();
				var height = window.innerHeight - 30;/*60 is for making a 30 pixel space on top and bottom*/
				var max_width = window.innerWidth - 10;/*-10 to allow for at least 5 pixels to the edge of the screen*/
				height = height > 700 ? 700 : height;
				var width = height / 75 * 100;
				var cover_width = width/2;
				var display = 'double';
				/*min supported size 480,340 */
				if(height < 480){
					height = 480;
				}
				if(width < 340){
					width = 340;
					max_width = 340;
					cover_width = 340;
				}
				if(width > max_width){
					display = 'single';
					width = max_width;
					cover_width = width;
				}
				o.options.width = cover_width;
				o.options.height = height;
				var cover_reduction = 20;/*hard coded, remove*/
				var cover_border = 20;/*hard coded, remove*/
				var cover_logo_margin_top = 25;/*hard coded, remove*/
				var cover_logo_margin_bottom = 25;/*hard coded, remove*/
				var cover_logo_width = 80;/*hard coded, remove*/
				var cover_clinic_logo_size = 130;/*hard coded, remove*/
				var cover_patient_size = 250;/*hard coded, remove*/
				var cover_patient_width = 100;/*hard coded, remove*/
				var cover_patient_position = 10;/*hard coded, remove*/
				var page_width = cover_width - cover_reduction;
				var page_height = height - cover_reduction + 2;
				var side_width = 5;
				var side_left_offset = cover_width*.9895;
				var side_top_offset = 0;
				var margin = 100;
				var depth_width = 16;
				var depth_height = height - 10;
				var depth_top_offset = 7;
				var depth_left_offset = 7;
				var depth_right_offset = 7;
				o.options.max_height = page_height - 120;
				$(".vetology_book_wrap").css({
					width: width + "px",
					height: height + "px",
					margin: margin + "px auto"
				});
				$(".vetology_pages").css({
					width: width + "px",
					height: height + "px"
				});
				$(".vetology_pages .cover_1 .side").css({
					width: side_width + "px",
					height: height + "px",
					left: side_left_offset + "px",
					top: side_top_offset + "px"
				});
				$(".vetology_pages .book_cover .depth").css({
					width: depth_width + "px",
					height: depth_height + "px",
					top: depth_top_offset + "px"
				});
				$(".vetology_pages .cover_2 .depth").css({
					left: depth_left_offset + "px"
				});
				$(".vetology_pages .cover_3 .depth").css({
					right: depth_right_offset + "px"
				});
				$(".book_page").css({
					width: cover_width + "px",
					height: height + "px"
				});
				/*
				$(".book_page").css({
					width: page_width + "px",
					height: page_height + "px"
				});*/
				$(".book_page.even").css({
					"margin-left": (width - page_width) + "px"
				});
				$(".vetology_pages .book_cover").css({
					width: cover_width + "px",
					height: height + "px"
				});
				$(".book_cover.cover_1 .page_content, .book_cover.cover_4 .page_content").css({
					"border-width": cover_border + "px"
				});
				$(".book_cover.cover_1 .vetology_logo").css({
					"margin-top": cover_logo_margin_top + "px",
					"margin-bottom": cover_logo_margin_bottom + "px"
				});
				$(".book_cover.cover_1 .vetology_logo img").css({
					width: cover_logo_width + "%"
				});
				$(".vetology_pages .clinic_logo").css({
					height: cover_clinic_logo_size + "px"
				});
				$(".vetology_pages .patient_presentation").css({
					height: cover_patient_size + "px",
					width: cover_patient_width + "%",
					bottom: cover_patient_position + "px"
				});
				return display;
			},
			/*
			 * Vetology.o.options._captureResize
			 *
			 * @description	Placeholder for a method
			 *
			 * @return NULL
			 *
			 */
			updateDepth: function(book, newPage){
				var page = book.turn('page'),
				pages = book.turn('pages'),
				depthWidth = 16*Math.min(1, page*2/pages);
				newPage = newPage || page;
				if(pages === newPage){
					book.addClass("last_page");
				} else {
					book.removeClass("last_page");
				}
				if(newPage>3){
					$('.vetology_pages .cover_2 .depth').css({
						width: depthWidth,
						left: 20 - depthWidth
					});
				} else {
					$('.vetology_pages .cover_2 .depth').css({width: 0});
				}
				depthWidth = 16*Math.min(1, (pages-page)*2/pages);
				if(newPage<pages-3){
					$('.vetology_pages .cover_3 .depth').css({
						width: depthWidth,
						right: 20 - depthWidth
					});
				} else {
					$('.vetology_pages .cover_3 .depth').css({width: 0});
				}
			},
			loadPage: function(page){
				$('.vetology_pages .p' + page).html("sample contnet");
			},
			addPage: function(page, book){
				var o = this;
				var id, pages = book.turn('pages');
				if (!book.turn('hasPage', page)) {
					var p = o._getBookPages([], page);
					book.turn('addPage', p, page)
				}
			},
			_setBookSections: function(){
  				var o = this;
                  const sectionAccess = o.options.section_access;
				var meta = o.options.bookMeta;
                const sections = [];
                sections.push(o._getPatientIfoSection(meta));
                sections.push(o._getPassportSection(meta));
                if (sectionAccess.show_docs) {
                    sections.push(o._getDocsSection(meta));
                }
                if (sectionAccess.show_images) {
                    sections.push(o._getStudiesSection(meta));
                }
                if (sectionAccess.show_appointments) {
                    sections.push(o._getAppointmentsSection(meta));
                }
                if (sectionAccess.show_history) {
                    sections.push(o._getHistorySection(meta));
                }
                if (sectionAccess.show_panels) {
                    sections.push(o._getLabSection(meta));
                }
                if (sectionAccess.show_prescriptions) {
                    sections.push(o._getPrescriptionsSection(meta));
                }

                o.options.sections = sections;

			},
			_getAppointmentsSection: function(meta){
				var o = this;
				var section = {
					title: "Appointments",
					identifier: "appointments",
					content: [],
					is_table: true,
					table_before: false,
					table_head: [
						"Subject",
						"Status",
						"Operatory",
						"Note"
					],
					table_body_alignment: [
						"left",
						"center",
						"left",
						"left"
					],
					table_body: [],
					icon: "calendar"
				};
				var appts = o.options.appointments;
				if(appts.length > 0){
					section.content.push('<h4 class="section_id section_title_index" data-id="appointments">Appointments</h4>');
					$.each(appts, function(a, p){
						section.table_body.push([
							p.subject,
							p.status,
							p.operatory + '<br>On: ' + p.on + '<br>@: ' + p.at,
							p.description
						]);
					});
				} else {
					section.content.push('<h4 class="section_id section_title_index" data-id="appointments">Appointments</h4>');
					section.content.push('<p class="text-center">No appointments yet</p>');
				}
				return section;
			},
			_getDocsSection: function(meta){
				var o = this;
				var section = {
					title: "Documents",
					identifier: "documents",
					content: [],
					is_table: true,
					table_before: false,
					table_head: [
						"Name",
						"Uploaded On",
						"View",
						"Download"
					],
					table_body: [],
					icon: "file"
				};
				var docs = o.options.docs;
				section.content.push('<h4 class="section_id section_title_index" data-id="documents_uploader">Documents Uploader</h4>');
				o.options.def["documents_uploader"] = {
					text: "Documents Uploader",
					section: 'documents'
				};
				section.content.push('<div data-url="/" class="flipbook_docs docs_uploader" data-target="case_upload"></div>');
				if(docs.length === 0){
					section.content.push('<p class="text-center">No documents yet</p>');
				}
				section.content.push(false);
				if(docs.length > 0){
					section.content.push('<h4 class="section_id section_title_index" data-id="documnets_list">Documents List</h4>');
					o.options.def["documnets_list"] = {
						text: "Documents List",
						section: 'documents'
					};
					$.each(docs, function(a, p){
						section.table_body.push([
							p.name.length <= 35 ? p.name : '<span title = "' + p.name + '">' + p.name.substring(0, 32) + '...' + '</span>',
							p.date,
							p.deleted ? '<span class="label label-danger">DELETED</span>' : '<a target="_blank" href="/ca/do/u?t=inline&f=' + p.CaseDocID + '&report_access_source_id=4&report_feedback=1" class="vetology-view"></a>',
							p.deleted ? '<span class="label label-danger">DELETED</span>' : '<a target="_blank" href="/ca/do/u?f=' + p.CaseDocID + '&report_access_source_id=4" class="vetology-circle-down"></a>'
						]);
					});
				}

				// add the reports
				const reports = o.options.reports;
				if (reports.length > 0) {
					if (docs.length == 0) {
						section.content.push('<h4 class="section_id section_title_index" data-id="reports_list">Reports List</h4>');
					}
					o.options.def["reports_list"] = {
						text: "Reports List",
						section: 'documents'
					};
					$.each(reports, function (a, p) {
						section.table_body.push([
							p.name.length <= 35 ? p.name : '<span title = "' + p.name + '">' + p.name.substring(0, 32) + '...' + '</span>',
							p.date,
							'<a target="_blank" href="/report/v/' + p.type + '/' + p.CaseID + '?report_access_source_id=4" class="vetology-view"></a>',
							'<a target="_blank" href="/report/d/' + p.type + '/' + p.CaseID + '?report_access_source_id=4" class="vetology-circle-down"></a>'
						]);
						
					});
				}
				return section;
			},
			_getPrescriptionsSection: function(meta){
				var o = this;
				var section = {
					title: "Prescriptions",
					identifier: "prescriptions",
					content: [],
					is_table: true,
					table_before: false,
					table_head: [
						"Description",
						"Quantity",
						"Fill date",
						"By"
					],
					table_body_alignment: [
						"left",
						"center",
						"center",
						"left"
					],
					table_body: [],
					icon: "prescription"
				};
				var prescriptions = o.options.prescriptions;
				console.log(prescriptions);
				if(prescriptions.length > 0){
					section.content.push('<h4 class="section_id section_title_index" data-id="prescriptions">Prescriptions</h4>');
					$.each(prescriptions, function(a, p){
						section.table_body.push([
							'<a class="doPop" title="' + p.desc + '" data-content="' + p.direction + '"><i class="vetology-information"></i></a>&nbsp;' + p.desc,
							p.quantity,
							p.date,
							p.clinic
						]);
					});
				} else {
					section.content.push('<h4 class="section_id section_title_index" data-id="prescriptions">Prescriptions</h4>');
					section.content.push('<p class="text-center">No prescriptions yet</p>');
				}
				return section;
			},
			_getLabSection: function(meta){
				var o = this;
				var section = {
					title: "Lab panels",
					identifier: "lab_panels",
					content: [],
					is_table: false,
					table_before: false,
					table_head: [
						"Test",
						"Result",
						"Odds Ratio",
						"Rank",
						"Value",
						"More",
					],
					table_body: [],
					icon: "beaker-full-reacting"
				};
				var amie = '<span class="vetology-amie"><span class="main_head"></span><span class="vetology_logo-1"></span><span class="vetology_logo-2"></span><span class="vetology_logo-3"></span><span class="vetology_logo-4"></span><span class="vetology_logo-5"></span><span class="vetology_logo-6"></span><span class="vetology_logo-7"></span><span class="brain"></span></span>';
				var panels = o.options.lab;
				if(panels.length > 0){
					section.content.push('<h4 class="section_title_index">INDEX</h4>');
					section.content.push('<a href="#" data-id="panels_graph" class="vetology_pd index_list_item flipbook_page_finder">History Graphs</a>');
					section.content.push('<a href="#" data-id="panels_graph_map" class="vetology_pd index_list_item flipbook_page_finder">Geo Data</a>');
					o.options.def["panels_graph"] = {
						text: "History Graphs",
						section: 'lab_panels'
					};
					section.content.push('<span class="index_list_titles"><span class="index_list_title">DATE</span><span class="index_list_title">Test Name</span></span>');
					$.each(panels, function(a, panel){
						o.options.def["panel_" + panel.id] = {
							text: panel.date,
							section: 'lab_panels'
						};
						section.content.push('<span class="index_list_row"><a href="#" data-id="panel_' + panel.id + '" class="vetology_pd index_list_item flipbook_page_finder">' + panel.date + ' </span><span></a></span>');
					});
					section.content.push(false);
					section.content.push('<h4 class="section_id section_title_index" data-id="panels_graph">History Graphs</h4>');
					var g = '<div class="graph_canvas">';
					g += '<select class="graph_changer form-control">';
					g += '<option selected="selected" disabled="disabled">Select a value to compare</option>';
					$.each(o.options.graph, function(i, val){
						g += '<option value="' + i + '">' + i + ' (' + val.length + ' test' + (val.length > 1 ? 's' : '') + ')</option>';
					});
					g += '</select>';
					g += '<br>';
					g += '<select class="graph_type form-control">';
					g += '<option disabled="disabled" value="">Select a type of chart</option>';
					g += '<option selected="selected" value="Bar">Bar</option>';
					g += '<option value="AreaChart">Area</option>';
					g += '<option value="AnnotationChart">Annotation</option>';
					g += '</select>';
					g += '<div class="canvas"></div>';
					g += '</div>';
					section.content.push(g);
					section.content.push(false);
					section.content.push('<h4 class="section_id section_title_index" data-id="panels_graph_map">Geo Data</h4>');
					var map = '<div data-type="9" class="geoMap" data-map="lab_panels" data-zoom="18" data-maxzoom="18" data-minzoom="18" data-geolocate="true"></div>';
					o.options.def["panels_graph_map"] = {
						text: "Geo Data",
						section: 'lab_panels'
					};
					section.content.push(map);
					section.content.push(false);
					$.each(panels, function(a, panel){
						if(panel.results.length > 0){
							section.content.push('<h4 class="section_id section_title_index" data-id="panel_' + panel.id + '">' + panel.date + '</h4>');
							section.content.push('STAR_TABLE');
							$.each(panel.results, function(i, p){
								o.options.lab_descriptions[p.name] = p.desc;
								section.content.push([
									p.name + "<br>" + p.unit,
									'<span class="panel_' + (p.normal ? 'normal' : 'abnormal') + '">' + p.result + '</span>',
									"Soon",
									"Soon",
									'<a href="#" class="vetology_pd btn bg-maroon btn-flat lab_test_desc" data-test="' + p.name + '">More Info</a>',
									'<div class="btn_lab_group"><a href="#" class="vetology_pd amie_trigger" data-test="' + p.name + '">' + amie + '</a></div>',
								]);
							});
							section.content.push('END_TABLE');
							section.content.push(false);
						}
					});
					$.each(panels, function(a, panel){
						if (panel.resultsGraphed.length > 0) {
							o._buildGraphedLabSection(panel, section);
						}
					});
				} else {
					section.content.push('<h4 class="section_id section_title_index" data-id="lab_panels">Lab panels</h4>');
					section.content.push('<p class="text-center">No lab panels yet</p>');
				}
				return section;
			},
			_buildGraphedLabSection() {
				section.content.push('<h4 class="section_id section_title_index" data-id="panel_' + panel.id + '">' + panel.date + '</h4>');
				section.content.push('STAR_TABLE');
				$.each(panel.resultsGraphed, function (i, p) {
					o.options.lab_descriptions[p.name] = p.desc;
					var l = p.unit === '%' ? 0 : parseFloat(p.low);
					var h = p.unit === '%' ? 100 : parseFloat(p.high);
					var v = parseFloat(p.result);
					var res = '<div class="panel_result">';
					if (v > l && v < h) {
						res += '<span class="panel_low">' + l + '</span><span class="panel_' + (p.normal ? 'normal' : 'abnormal') + '">' + v + '</span><span class="panel_high">' + h + '</span>';
					} else if (v > l && v > h) {
						res += '<span class="panel_low">' + l + '</span><span class="panel_high">' + h + '</span><span class="panel_' + (p.normal ? 'normal' : 'abnormal') + '">' + v + '</span>';
					} else if (v < l && v < h) {
						res += '<span class="panel_' + (p.normal ? 'normal' : 'abnormal') + '">' + v + '</span><span class="panel_low">' + l + '</span><span class="panel_high">' + h + '</span>';
					} else {
						res += '<span class="panel_low">' + l + '</span><span class="panel_' + (p.normal ? 'normal' : 'abnormal') + '">' + v + '</span><span class="panel_high">' + h + '</span>';
					}
					res += '</div>';
					section.content.push([
						p.name + "<br>" + p.unit,
						res,
						"Soon",
						"Soon",
						'<a href="#" class="vetology_pd btn bg-maroon btn-flat lab_test_desc" data-test="' + p.name + '">More Info</a>',
						'<div class="btn_lab_group">' +
						'<a href="#" class="vetology_pd bar_chart" data-test="' + p.name + '"><span class="vetology-bar-chart"></span></a>' +
						'<a href="#" class="vetology_pd plot_chart" data-test="' + p.name + '"><span class="vetology-bubble-chart"></span></a>' +
						'<a href="#" class="vetology_pd amie_trigger" data-test="' + p.name + '">' + amie + '</a></div>'
					]);
				});
				section.content.push('END_TABLE');
				section.content.push(false);

			},
			_getHistorySection: function(meta){
				var o = this;
				var section = {
					title: "Medical History",
					identifier: "medical_history",
					content: [],
					is_table: false,
					icon: "case"
				};
				var visits = o.options.visits;
				if(visits.length > 0){
					section.content.push('<h4 class="section_title_index">INDEX</h4>');
					section.content.push('<span class="index_list_title">DATE</span>');
					$.each(visits, function(i, v){
						section.content.push('<a href="#" data-id="' + v.id + '" class="vetology_pd index_list_item flipbook_page_finder">' + v.date + '</a>');
						o.options.def[v.id] = {
							text: v.date,
							section: 'medical_history'
						};
					});
					section.content.push(false);
					$.each(visits, function(i, v){
						section.content.push('<span class="section_id" data-id="' + v.id + '"></span>');
                        v.history.forEach(function(content, idx) {
                            if (content.length < 100 && typeof v.history[idx + 1] != 'undefined' && v.history[idx + 1] != false) {
                                v.history[idx] += '<br>' + v.history[idx + 1];
                                v.history.splice(idx + 1, 1);
                            }
                        })
						$.each(v.history, function(t, d){
                            o.paginateSection(d, section);
						});
						section.content.push(false);
					});
				}
				return section;
			},
			_getStudiesSection: function(meta){
				var o = this;
				var studies = o.options.studies;
				var thumb = o.options.thumb;
				var section = {
					title: "Patient studies",
					content: [],
					is_table: true,
					table_before: false,
					identifier: "patient_studies",
					icon: "dicom",
					table_head: [
						"Performed at",
						"Info",
						"Download",
					],
					table_body: []
				};
				if(o.options.studies_count > 0){
					section.content.push('<h4 class="section_id section_title_index" data-id="patient_studies">Patient studies</h4>');
					let content = '';
					if (o.options.study_link &&  o.options.study_modality != 'US') {
						content = `
							<div class="studies_preview">
								<a href="/patient-manager?id=${o.options.study_link}" target="_blank">
									<figure>
										<img title="${meta.patient.name}" src="/download/${thumb}">
										<figcaption>${meta.patient.name} - Click to View Images</figcaption>
									</figure>
								</a>
							</div>
						`;
					} 
                    section.content.push(content);
					$.each(studies, function(i, s){
						section.table_body.push([
							s.clinic + "<br>On: " + s.date,
							"Modality: " + s.modality + "<br>" + s.images + " image" + (s.images > 1 ? "s" : "") + " in " + s.series.length + " series",
							'<a href="/download/' + s.download + '" target="_blank"><span class="vetology-circle-down"></span></a>'
						]);
					});
				} else {
					section.is_table = false;
					section.content.push('<h4 class="section_id section_title_index" data-id="patient_studies">Patient studies</h4>');
					section.content.push('<p class="text-center">No studies yet</p>');
				}
				return section;
			},
			_getPatientIfoSection: function(meta){
				var o = this;
				var section = {
					title: "Patient Detail",
					content: [],
					is_table: false,
					identifier: "patient_detail",
					icon: "patients"
				};
				var html = '<h4>Patient Information</h4>';
				html += '<p class="list_items">';
				html += '<span class="list_title">Name:</span> ';
				html += '<span class="list_value">';
				html += meta.patient.name;
				html += '</span>';
				html += '</p>';
				html += '<p class="list_items">';
				html += '<span class="list_title">Birthdate:</span> ';
				html += '<span class="list_value">';
				html += meta.patient.birth;
				html += '</span>';
				html += '</p>';
				html += '<p class="list_items">';
				html += '<span class="list_title">Sex:</span> ';
				html += '<span class="list_value">';
				html += meta.patient.sex;
				html += '</span>';
				html += '</p>';
				html += '<p class="list_items">';
				html += '<span class="list_title">Species:</span> ';
				html += '<span class="list_value">';
				html += meta.patient.species + " " + meta.patient.breed;
				html += '</span>';
				html += '</p>';
                html += '<p class="list_items">';
                html += '<span class="list_title">Weight:</span> ';
                html += '<span class="list_value">';
                html += meta.patient.weight;
                html += '</span>';
                html += '</p>';
				section.content.push(html);
                if (meta.owner.name.trim().length > 0 || meta.owner.phones.length > 0 || meta.owner.cells.length > 0 || meta.owner.emails.length > 0) {
                    html = '<h4>Responsible party information</h4>';
                    html += '<p class="list_items">';
                    html += '<span class="list_title">Name:</span> ';
                    html += '<span class="list_value">';
                    html += meta.owner.name;
                    html += '</span>';
                    html += '</p>';
                    if(meta.owner.phones.length > 0){
                        html += '<p class="list_items">';
                        html += '<span class="list_title">Phone:</span> ';
                        html += '<span class="list_value">';
                        html += meta.owner.phones.join(", ");
                        html += '</span>';
                        html += '</p>';
                    }
                    if(meta.owner.cells.length > 0){
                        html += '<p class="list_items">';
                        html += '<span class="list_title">Cell-Phone:</span> ';
                        html += '<span class="list_value">';
                        html += meta.owner.cells.join(", ");
                        html += '</span>';
                        html += '</p>';
                    }
                    if(meta.owner.emails.length > 0){
                        html += '<p class="list_items">';
                        html += '<span class="list_title">E-mail:</span> ';
                        html += '<span class="list_value">';
                        html += meta.owner.emails.join(", ");
                        html += '</span>';
                        html += '</p>';
                    }
                    section.content.push(html);
                }
				html = '<h4>Hospital information</h4>';
				html += '<p class="list_items">';
				html += '<span class="list_title">Name:</span> ';
				html += '<span class="list_value">';
				html += meta.clinic.name;
				console.log(meta.clinic);
				html += '</span>';
				html += '</p>';
				html += '<p class="list_items">';
				html += '<span class="list_title">Address:</span> ';
				html += '<span class="list_value">';
				html += meta.clinic.address;
				html += '</span>';
				html += '</p>';
				if(meta.clinic.phone.length > 0){
					html += '<p class="list_items">';
					html += '<span class="list_title">Phone:</span> ';
					html += '<span class="list_value">';
					html += meta.clinic.phone;
					html += '</span>';
					html += '</p>';
				}
				if(meta.clinic.fax.length > 0){
					html += '<p class="list_items">';
					html += '<span class="list_title">Fax:</span> ';
					html += '<span class="list_value">';
					html += meta.clinic.fax;
					html += '</span>';
					html += '</p>';
				}
				if(meta.clinic.email.length > 0){
					html += '<p class="list_items">';
					html += '<span class="list_title">Email:</span> ';
					html += '<span class="list_value">';
					html += meta.clinic.email;
					html += '</span>';
					html += '</p>';
				}
				section.content.push(html);
				return section;
			},
			_getPassportSection: function(meta){
				var o = this;
				var section = {
					title: "Passport",
					content: [],
					is_table: false,
					identifier: "patient_passport",
					icon: "pet-passport"
				};
				var html = '<h4>Patient Passport</h4>';
				html += '<div class="pet_passport">';
				html += '<div class="pet_passport_inner">';
				o.options.def["pass_ownership"] = {
					text: "I. DETAILS OF OWNERSHIP",
					section: 'patient_passport'
				};
				html += '<h4 class="pet_passport_title section_id" data-id="pass_ownership">I. DETAILS OF OWNERSHIP</h4>';
				html += '<div class="pet_passport_sections">';
				html += '<div class="pet_passport_section">';
				html += '<span class="pet_passport_section_number">1.</span>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Name:</span> <span class="pet_passport_section_value">' + meta.owner.name + '</span></p>';
				if(meta.owner.phones.length > 0){
					html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Phone:</span> <span class="pet_passport_section_value">' + meta.owner.phones.join(", ") + '</span></p>';
				}
				if(meta.owner.work_phones.length > 0){
					html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Work Phone:</span> <span class="pet_passport_section_value">' + meta.owner.work_phones.join(", ") + '</span></p>';
				}
				if(meta.owner.cells.length > 0){
					html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Cell Phone:</span> <span class="pet_passport_section_value">' + meta.owner.cells.join(", ") + '</span></p>';
				}
				if(meta.owner.emails.length > 0){
					html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Email:</span> <span class="pet_passport_section_value">' + meta.owner.emails.join(", ") + '</span></p>';
				}
				html += '</div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				section.content.push(html);
				html = '<div class="pet_passport">';
				html += '<div class="pet_passport_inner">';
				o.options.def["pass_desc_animal"] = {
					text: "II. DESCRIPTION OF ANIMAL",
					section: 'patient_passport'
				};
				html += '<h4 class="pet_passport_title section_id" data-id="pass_desc_animal">II. DESCRIPTION OF ANIMAL</h4>';
				html += '<div class="pet_passport_sections">';
				html += '<div class="pet_passport_section">';
				html += '<span class="pet_passport_section_number">1.</span>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Name*:</span> <span class="pet_passport_section_value">' + meta.patient.name + '</span></p>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Species:</span> <span class="pet_passport_section_value">' + meta.patient.species + '</span></p>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Breed*:</span> <span class="pet_passport_section_value">' + meta.patient.breed + '</span></p>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Sex:</span> <span class="pet_passport_section_value">' + meta.patient.sex + '</span></p>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Date of Birth*:</span> <span class="pet_passport_section_value">' + meta.patient.birth + '</span></p>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Color:</span> ' +
                    '<span class="pet_passport_section_value">' + meta.patient.patientAdditional.Color + '</span></p>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Any notable or dicernable features or characteristic:</span> ' +
                    '<span class="pet_passport_section_value">' + meta.patient.patientAdditional.NotableFeatures + '</span></p>';
				html += '<p>* As stated by owner</p>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				section.content.push(html);
				html = '<div class="pet_passport">';
				html += '<div class="pet_passport_inner">';
				o.options.def["pass_mark_animal"] = {
					text: "III. MARKING OF ANIMAL",
					section: 'patient_passport'
				};
				html += '<h4 class="pet_passport_title section_id" data-id="pass_mark_animal">III. MARKING OF ANIMAL</h4>';
				html += '<div class="pet_passport_sections">';
				html += '<div class="pet_passport_section">';
				html += '<span class="pet_passport_section_number">1.</span>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Transponder alphanumeric code</span></p>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_value">' + meta.patient.patientAdditional.TransponderCode + '</span></p>';
                html += '</div>';
				html += '<div class="pet_passport_section">';
				html += '<span class="pet_passport_section_number">2.</span>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Location of the transponder</span></p>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_value">' + meta.patient.patientAdditional.TransponderLocation + '</span></p>';
				html += '</div>';
				html += '<div class="pet_passport_section">';
				html += '<span class="pet_passport_section_number">3.</span>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Tattoo alphanumeric code</span></p>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_value">' + meta.patient.patientAdditional.TatooCode + '</span></p>';
				html += '</div>';
				html += '<div class="pet_passport_section">';
				html += '<span class="pet_passport_section_number">4.</span>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Location of the Tattoo</span></p>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_value">' + meta.patient.patientAdditional.TatooLocation +'</span></p>';
				html += '</div>';

                html += '<div class="pet_passport_section">';
                html += '<span class="pet_passport_section_number">5.</span>';
                html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Vaccination Status</span></p>';
                html += '<p class="pet_setion_inner"><span class="pet_passport_section_value">' + meta.patient.patientAdditional.VaccinationStatus +'</span></p>';
                html += '</div>';

                html += '<div class="pet_passport_section">';
                html += '<span class="pet_passport_section_number">5.</span>';
                html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Deworming Status</span></p>';
                html += '<p class="pet_setion_inner"><span class="pet_passport_section_value">' + meta.patient.patientAdditional.DewormingStatus +'</span></p>';
                html += '</div>';


                html += '</div>';
				html += '</div>';
				html += '</div>';
				section.content.push(html);
				/*
				html = '<div class="pet_passport">';
				html += '<div class="pet_passport_inner">';
				o.options.def["pass_issuing"] = {
					text: "IV. ISSUING OF THE PASSPORT",
					section: 'patient_passport'
				};
				html += '<h4 class="pet_passport_title section_id" data-id="pass_issuing">IV. ISSUING OF THE PASSPORT</h4>';
				html += '<div class="pet_passport_sections">';
				html += '<div class="pet_passport_section">';
				html += '<span class="pet_passport_section_number">1.</span>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Name of the authorized veterinarian</span></p>';
				html += '<span class="pet_passport_section_value">John Doe</span></p>';
				html += '</div>';
				html += '<div class="pet_passport_section">';
				html += '<span class="pet_passport_section_number">2.</span>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Address</span></p>';
				html += '<span class="pet_passport_section_value">123 Sample road...</span></p>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Post/Zip code</span></p>';
				html += '<span class="pet_passport_section_value">12345</span></p>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Country</span></p>';
				html += '<span class="pet_passport_section_value">United States</span></p>';
				html += '</div>';
				html += '<div class="pet_passport_section">';
				html += '<span class="pet_passport_section_number">3.</span>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Telephone number</span></p>';
				html += '<span class="pet_passport_section_value">+1 123 456 7890</span></p>';
				html += '</div>';
				html += '<div class="pet_passport_section">';
				html += '<span class="pet_passport_section_number">4.</span>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Email address</span></p>';
				html += '<span class="pet_passport_section_value"><a href="mailto:sample@vet.net">sample@vet.net</a></span></p>';
				html += '</div>';
				html += '<div class="pet_passport_section">';
				html += '<span class="pet_passport_section_number">5.</span>';
				html += '<p class="pet_setion_inner"><span class="pet_passport_section_name">Date of issuing</span></p>';
				html += '<span class="pet_passport_section_value">Jan 05 2010</span></p>';
				html += '</div>';
				html += '</div>';
				section.content.push(html);*/


/*
				html = '<div class="pet_passport">';
				html += '<div class="pet_passport_inner">';
				o.options.def["pass_vac_rabies"] = {
					text: "IV. VACC. AGAINST RABIES",
					section: 'patient_passport'
				};
				html += '<h4 class="pet_passport_title section_id" data-id="pass_vac_rabies">IV. VACCINATION AGAINST RABIES</h4>';
				html += '<div class="pet_passport_sections_vac">';
				html += '<div class="pet_passport_section_vac">';
				html += '<div class="pet_passport_vac_3 pet_passport_vac_3_titles">';
				html += '<div class="pet_passport_vac_0">';
				html += '<h5>MANUFACTURER, BATCH #, NAME OF VACCINE</h5>';
				html += '</div>';
				html += '<div class="pet_passport_vac_1">';
				html += '<h5>VACCINATION DATE<sup>1</sup><br>VALID UNTIL<sup>2</sup></h5>';
				html += '</div>';
				html += '<div class="pet_passport_vac_2">';
				html += '<h5>AUTHORIZED VETERINARIAN</h5>';
				html += '</div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_3">';
				html += '<div class="pet_passport_vac_0">';
				html += '<div class="pet_passport_vac_inner">';
				html += '<div>';
				html += '<div class="vac_title">';
				html += '<span class="vac_title_left"></span>';
				html += '<span class="vac_title_right"></span>';
				html += '</div>';
				html += '<div class="vac_body">';
				html += '<div class="vac_body_line"><span class="vac_body_left vac_body_line_1">Batch:</span><span class="vac_body_right vac_body_line_1"></span></div>';
				html += '<div class="vac_body_line"><span class="vac_body_left vac_body_line_2">Exp:</span><span class="vac_body_right vac_body_line_2"></span></div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_1">';
				html += '<div class="pet_passport_vac_inner_h"><sup>1</sup> <span class="hand_written"></span></div>';
				html += '<div class="pet_passport_vac_inner_h"><sup>2</sup> <span class="hand_written"></span></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_2">';
				html += '<div class="pet_passport_vac_inner"><span class="hand_written"></span></div>';
				html += '</div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_3">';
				html += '<div class="pet_passport_vac_0">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_1">';
				html += '<div class="pet_passport_vac_inner_h"><sup>1</sup></div>';
				html += '<div class="pet_passport_vac_inner_h"><sup>2</sup></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_2">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_3">';
				html += '<div class="pet_passport_vac_0">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_1">';
				html += '<div class="pet_passport_vac_inner_h"><sup>1</sup></div>';
				html += '<div class="pet_passport_vac_inner_h"><sup>2</sup></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_2">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				section.content.push(html);
				html = '<div class="pet_passport">';
				html += '<div class="pet_passport_inner">';
				o.options.def["pass_anti_ech"] = {
					text: "V. ANTI-ECHINOCOCCUS",
					section: 'patient_passport'
				};
				html += '<h4 class="pet_passport_title section_id" data-id="pass_anti_ech">V. ANTI-ECHINOCOCCUS TREATMENT</h4>';
				html += '<div class="pet_passport_sections_vac">';
				html += '<div class="pet_passport_section_vac">';
				html += '<div class="pet_passport_vac_3 pet_passport_vac_3_titles">';
				html += '<div class="pet_passport_vac_0">';
				html += '<h5>MANUFACTURER, NAME OF PRODUCT</h5>';
				html += '</div>';
				html += '<div class="pet_passport_vac_1">';
				html += '<h5>DATE<sup>1</sup><br>TIME<sup>2</sup></h5>';
				html += '</div>';
				html += '<div class="pet_passport_vac_2">';
				html += '<h5>VETERINARIAN</h5>';
				html += '</div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_3">';
				html += '<div class="pet_passport_vac_0">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_1">';
				html += '<div class="pet_passport_vac_inner_h"><sup>1</sup></div>';
				html += '<div class="pet_passport_vac_inner_h"><sup>2</sup></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_2">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_3">';
				html += '<div class="pet_passport_vac_0">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_1">';
				html += '<div class="pet_passport_vac_inner_h"><sup>1</sup></div>';
				html += '<div class="pet_passport_vac_inner_h"><sup>2</sup></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_2">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_3">';
				html += '<div class="pet_passport_vac_0">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_1">';
				html += '<div class="pet_passport_vac_inner_h"><sup>1</sup></div>';
				html += '<div class="pet_passport_vac_inner_h"><sup>2</sup></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_2">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				section.content.push(html);
				html = '<div class="pet_passport">';
				html += '<div class="pet_passport_inner">';
				o.options.def["pass_anti_parasit"] = {
					text: "VI. OTHER ANTI-PARASIT",
					section: 'patient_passport'
				};
				html += '<h4 class="pet_passport_title section_id" data-id="pass_anti_parasit">VI. OTHER ANTI-PARASIT TREATMENTS</h4>';
				html += '<div class="pet_passport_sections_vac">';
				html += '<div class="pet_passport_section_vac">';
				html += '<div class="pet_passport_vac_3 pet_passport_vac_3_titles">';
				html += '<div class="pet_passport_vac_0">';
				html += '<h5>MANUFACTURER, NAME OF PRODUCT</h5>';
				html += '</div>';
				html += '<div class="pet_passport_vac_1">';
				html += '<h5>DATE<sup>1</sup><br>TIME<sup>2</sup></h5>';
				html += '</div>';
				html += '<div class="pet_passport_vac_2">';
				html += '<h5>VETERINARIAN</h5>';
				html += '</div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_3">';
				html += '<div class="pet_passport_vac_0">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_1">';
				html += '<div class="pet_passport_vac_inner_h"><sup>1</sup></div>';
				html += '<div class="pet_passport_vac_inner_h"><sup>2</sup></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_2">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_3">';
				html += '<div class="pet_passport_vac_0">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_1">';
				html += '<div class="pet_passport_vac_inner_h"><sup>1</sup></div>';
				html += '<div class="pet_passport_vac_inner_h"><sup>2</sup></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_2">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_3">';
				html += '<div class="pet_passport_vac_0">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_1">';
				html += '<div class="pet_passport_vac_inner_h"><sup>1</sup></div>';
				html += '<div class="pet_passport_vac_inner_h"><sup>2</sup></div>';
				html += '</div>';
				html += '<div class="pet_passport_vac_2">';
				html += '<div class="pet_passport_vac_inner"></div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';
				html += '</div>';

				section.content.push(html);
            */
				return section;
			},
			_setBookPrintPages: function(content, section){
				section = typeof section === "undefined" ? {is_table:false} : section;
				var o = this;
				var height_tester = $(".print_page_sampler").find(".page_content_inner");
				var max_height = height_tester.height();
				var meta = o.options.bookMeta;
				var page_html = '<div class="book_page"><div class="page_content"><div class="page_content_inner"></div></div></div>';;
				var canvas = $(".book_printer");
				var page = page_html;
				if(canvas.find(".book_page").length > 0 && canvas.find(".book_page").last().find(".page_content_inner").html() === ""){
					page = canvas.find(".book_page").last();
				} else {
					page = page_html;
					page = $(page_html);
					canvas.append(page);
				}
				var header;
				var footer;
				var html;
				var page_content = "";
				var page_content_test = "";
				if(section.is_table && section.table_before && section.table_body.length > 0){
					var row;
					var head = '<div><table class="table table-striped table-condensed"><thead>';
					head += '<tr>';
					$.each(section.table_head, function(i,th){
						head += '<th class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + th + '</th>';
					});
					head += '</tr>';
					head += '</thead><tbody>';
					page_content = head;
					$.each(section.table_body, function(i, d){
						row = '<tr>';
						$.each(d, function(a, v){
							row += '<td class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + v + '</td>';
						});
						row += '</tr>';
						page_content_test = page_content + "</tbody></table></div>";
						page.find(".page_content_inner").html(page_content_test);
						if(page.find(".page_content_inner").height() > max_height){
							page.find(".page_content_inner").html(page_content + '</tbody></table></div>');
							page = page_html;
							page = $(page_html);
							canvas.append(page);
							page_content = head + row;
							o.options.pages ++;
						} else {
							page_content += row;
						}
					});
				}
				var regex = new RegExp(/(data-id=")([^"]+)(")/g);
				if(page_content != ""){
					page.find(".page_content_inner").html(page_content + '</tbody></table></div>');
					page = page_html;
					page = $(page_html);
					canvas.append(page);
					page_content = "";
					o.options.pages ++;
				}
				page_content_test = "";
				var head = '';
				$.each(content, function(i, c){
					c = c === false ? "<br><br>" : c;
					if(
						c.indexOf("Documents Uploader") !== -1 ||
						c.indexOf("History Graphs") !== -1 ||
						c.indexOf("graph_canvas") !== -1 ||
						c.indexOf("Geo Data") !== -1 ||
						c.indexOf("geoMap") !== -1
					){
						return true;
					}

					[page, page_content, page_content_test, page_html, canvas, section, head] = o._setBookPrintPagesSetContent(page, page_content, page_content_test, page_html, canvas, head, section, c, regex, max_height);
				});
				if (section.is_table && !section.table_before && section.table_body.length > 0) {
					[page, page_content] = o._setBookPrintPagesSetTableContent(page, canvas, page_html, section, page_content, max_height );
				}
				if(page_content !==  null){
					page.find(".page_content_inner").html(page_content);
				}
			},
			_setBookPrintPagesSetContent: function (page, page_content, page_content_test, page_html, canvas, head, section, c, regex, max_height) {
				const o = this;
				if (c === 'STAR_TABLE') {
					head = '<div><table class="table table-striped table-condensed"><thead>';
					head += '<tr>';
					$.each(section.table_head, function (i, th) {
						head += '<th class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + th + '</th>';
					});
					head += '</tr>';
					head += '</thead><tbody>';
					var row = '<tr>';
					$.each(section.table_head, function (i, th) {
						row += '<td class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + th + '</td>';
					});
					row += '</tr>';
					page_content_test = page_content + head + row + '</tbody></table></div>';
					page.find(".page_content_inner").html(page_content_test);
					if (page.find(".page_content_inner").height() > max_height) {
						page.find(".page_content_inner").html(page_content + '</tbody></table></div>');
						page = page_html;
						page = $(page_html);
						canvas.append(page);
						page_content = head + row;
						o.options.pages++;
					} else {
						page_content += head;
						page_content_test = page_content;
					}
				} else if (typeof c === 'object') {
					var row = '<tr>';
					$.each(c, function (i, td) {
						row += '<td class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + td + '</td>';
					});
					row += '</tr>';
					page_content_test = page_content + row + '</tbody></table></div>';
					page.find(".page_content_inner").html(page_content_test);
					if (page.find(".page_content_inner").height() > max_height) {
						page.find(".page_content_inner").html(page_content + '</tbody></table></div>');
						page = page_html;
						page = $(page_html);
						canvas.append(page);
						page_content = head + row;
						o.options.pages++;
					} else {
						page_content += row;
						page_content_test = page_content;
					}
				} else if (c === 'END_TABLE') {
					page_content_test += "</tbody></table></div>";
				} else {
					({ page_content_test, page, page_content } = o.setBookPrintPagesSetTextContent(page_content_test, c, page, regex, max_height,  page_content, page_html, canvas));
				}
				return [page, page_content, page_content_test, page_html, canvas, section, head];
			},
			_setBookPrintPagesSetTableContent(page, canvas, page_html, section, page_content, max_height) {
				const o = this;
				var row;
				var head = '<table class="table table-striped table-condensed"><thead>';
				head += '<tr>';
				$.each(section.table_head, function (i, th) {
					head += '<th class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + th + '</th>';
				});
				head += '</tr>';
				head += '</thead><tbody>';
				page_content += head;
				$.each(section.table_body, function (i, d) {
					row = '<tr>';
					$.each(d, function (a, v) {
						row += '<td class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + v + '</td>';
					});
					row += '</tr>';
					const page_content_test = page_content + "</tbody></table></div>";
					page.find(".page_content_inner").html(page_content_test);
					if (page.find(".page_content_inner").height() > max_height) {
						page.find(".page_content_inner").html(page_content + "</tbody></table></div>");
						page = page_html;
						page = $(page_html);
						canvas.append(page);
						page_content = head + row;
						o.options.pages++;
					} else {
						page_content += row;
					}
				});
				if (page_content != "") {
					page.find(".page_content_inner").html(page_content + "</tbody></table></div>");
					page = page_html;
					page = $(page_html);
					canvas.append(page);
					page_content = null;
					o.options.pages++;
				}
				return [page, page_content];
			},

			setBookPrintPagesSetTextContent: function (page_content_test, c, page, regex, max_height, page_content, page_html, canvas) {
				const o = this;
				page_content_test += c;
				page.find(".page_content_inner").html(page_content_test);
				var res = null;
				if(page_content_test !== null) {
					res = page_content_test.match(regex);
				}
				if (page.find(".page_content_inner").height() > max_height) {
					if (res !== null) {
						var final_ids = [];
						$.each(res, function (i, r) {
							r = r.replace('data-id="', '');
							r = r.replace('"', '');
							if (typeof o.options[r] === "undefined") {
								o.options.ids[r] = o.options.pages;
							}
						});
					}
					page.find(".page_content_inner").html(page_content);
					page = page_html;
					page = $(page_html);
					canvas.append(page);
					page_content = c;
					page_content_test = page_content;
					o.options.pages++;
				} else {
					if (res !== null) {
						var final_ids = [];
						$.each(res, function (i, r) {
							r = r.replace('data-id="', '');
							r = r.replace('"', '');
							if (typeof o.options[r] === "undefined") {
								o.options.ids[r] = o.options.pages;
							}
						});
					}
					page_content += c;
				}
				return { page_content_test, page, page_content };
			},

			_getBookPages: function(content, section){
				section = typeof section === "undefined" ? {is_table:false} : section;
				var o = this;
				var height_tester = $(".page_sampler .page_content_inner");
				var meta = o.options.bookMeta;
				var pages = [];
				var header;
				var footer;
				var html;
				var page_content = "";
				var page_content_test = "";
				if(section.is_table && section.table_before && section.table_body.length > 0){
					var row;
					var head = '<div class="table-responsive"><table class="table table-striped table-condensed"><thead>';
					head += '<tr>';
					$.each(section.table_head, function(i,th){
						head += '<th class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + th + '</th>';
					});
					head += '</tr>';
					head += '</thead><tbody>';
					page_content = head;
					$.each(section.table_body, function(i, d){
						row = '<tr>';
						$.each(d, function(a, v){
							row += '<td class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + v + '</td>';
						});
						row += '</tr>';
						page_content_test = page_content + "</tbody></table></div>";
						height_tester.html(page_content_test);
						if(height_tester.height() > o.options.max_height){
							html = '<div class="book_page">';
							html += '<div class="page_content">';
							html += o._getPageHeader();
							html += '<div class="page_content_inner">';
							html += page_content + "</tbody></table></div>";
							html += '</div>';
							html += o._getPageFooter(section);
							html += '</div>';
							html += '</div>';
							pages.push(html);
							page_content = head + row;
							o.options.pages ++;
						} else {
							page_content += row;
						}
					});
				}
				var regex = new RegExp(/(data-id=")([^"]+)(")/g);
				if(page_content != ""){
					html = '<div class="book_page">';
					html += '<div class="page_content">';
					html += o._getPageHeader();
					html += '<div class="page_content_inner">';
					html += page_content + "</tbody></table></div>";
					html += '</div>';
					html += o._getPageFooter(section);
					html += '</div>';
					html += '</div>';
					pages.push(html);
					page_content = "";
					o.options.pages ++;
				}
				page_content_test = "";
				var head = '';
				pages = o._getBookPagesSetContent(html, pages, section, content, page_content, page_content_test, height_tester, head, regex)
				return pages;
			},
			_getBookPagesSetContent: function (html, pages, section, content, page_content, page_content_test, height_tester, head, regex) {
				const o = this;
				$.each(content, function (i, c) {
					if (c === 'STAR_TABLE') {
						head = '<div class="table-responsive"><table class="table table-striped table-condensed"><thead>';
						head += '<tr>';
						$.each(section.table_head, function (i, th) {
							head += '<th class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + th + '</th>';
						});
						head += '</tr>';
						head += '</thead><tbody>';
						var row = '<tr>';
						$.each(section.table_head, function (i, th) {
							row += '<td class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + th + '</td>';
						});
						row += '</tr>';
						page_content_test = page_content + head + row + '</tbody></table></div>';
						height_tester.html(page_content_test);
						if (height_tester.height() > o.options.max_height) {
							html = '<div class="book_page">';
							html += '<div class="page_content">';
							html += o._getPageHeader();
							html += '<div class="page_content_inner">';
							html += page_content;
							html += '</div>';
							html += o._getPageFooter(section);
							html += '</div>';
							html += '</div>';
							pages.push(html);
							page_content = head + row;
							o.options.pages++;
						} else {
							page_content += head;
							page_content_test = page_content;
						}
					} else if (typeof c === 'object') {
						var row = '<tr>';
						$.each(c, function (i, td) {
							row += '<td class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + td + '</td>';
						});
						row += '</tr>';
						page_content_test = page_content + row + '</tbody></table></div>';
						height_tester.html(page_content_test);
						if (height_tester.height() > o.options.max_height) {
							html = '<div class="book_page">';
							html += '<div class="page_content">';
							html += o._getPageHeader();
							html += '<div class="page_content_inner">';
							html += page_content + '</tbody></table></div>';
							html += '</div>';
							html += o._getPageFooter(section);
							html += '</div>';
							html += '</div>';
							pages.push(html);
							page_content = head + row;
							o.options.pages++;
						} else {
							page_content += row;
							page_content_test = page_content;
						}
					} else if (c === 'END_TABLE') {
						page_content_test += "</tbody></table></div>";
					} else {
						({ page_content_test, html, page_content } = o.getBookPagesSetTextConent(page_content_test, c, height_tester, regex, html, page_content, section, pages));
					}
					return
				});
				if (section.is_table && !section.table_before && section.table_body.length > 0) {
					var row;
					var head = '<div class="table-responsive"><table class="table table-striped table-condensed"><thead>';
					head += '<tr>';
					$.each(section.table_head, function (i, th) {
						head += '<th class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + th + '</th>';
					});
					head += '</tr>';
					head += '</thead><tbody>';
					page_content += head;
					$.each(section.table_body, function (i, d) {
						row = '<tr>';
						$.each(d, function (a, v) {
							row += '<td class="text-' + (typeof section.table_body_alignment !== "undefined" ? section.table_body_alignment[i] : 'center') + '">' + v + '</td>';
						});
						row += '</tr>';
						page_content_test = page_content + "</tbody></table></div>";
						height_tester.html(page_content_test);
						if (height_tester.height() > o.options.max_height) {
							html = '<div class="book_page">';
							html += '<div class="page_content">';
							html += o._getPageHeader();
							html += '<div class="page_content_inner">';
							html += page_content + "</tbody></table></div>";
							html += '</div>';
							html += o._getPageFooter(section);
							html += '</div>';
							html += '</div>';
							pages.push(html);
							page_content = head + row;
							o.options.pages++;
						} else {
							page_content += row;
						}
					});
					if (page_content != "") {
						html = '<div class="book_page">';
						html += '<div class="page_content">';
						html += o._getPageHeader();
						html += '<div class="page_content_inner">';
						html += page_content + "</tbody></table></div>";
						html += '</div>';
						html += o._getPageFooter(section);
						html += '</div>';
						html += '</div>';
						pages.push(html);
						page_content = null;
						o.options.pages++;
					}
				}
				if (page_content !== null) {
					html = '<div class="book_page">';
					html += '<div class="page_content">';
					html += o._getPageHeader();
					html += '<div class="page_content_inner">';
					html += page_content;
					html += '</div>';
					html += o._getPageFooter(section);
					html += '</div>';
					html += '</div>';
					pages.push(html);
					o.options.pages++;
				}
				return pages;
			},

			getBookPagesSetTextConent: function(page_content_test, c, height_tester, regex, html, page_content, section, pages) {
				var o = this;
				page_content_test += c;
				height_tester.html(page_content_test);
				var res = null;
				if(page_content_test !== null) {
					res = page_content_test.match(regex);
				}
				if (height_tester.height() > o.options.max_height || c === false) {
					if (res !== null) {
						var final_ids = [];
						$.each(res, function (i, r) {
							r = r.replace('data-id="', '');
							r = r.replace('"', '');
							if (typeof o.options[r] === "undefined") {
								o.options.ids[r] = o.options.pages;
							}
						});
					}
					html = '<div class="book_page">';
					html += '<div class="page_content">';
					html += o._getPageHeader();
					html += '<div class="page_content_inner">';
					html += page_content;
					html += '</div>';
					html += o._getPageFooter(section);
					html += '</div>';
					html += '</div>';
					pages.push(html);
					page_content = c === false ? "" : c;
					page_content_test = page_content;
					o.options.pages++;
				} else {
					if (res !== null) {
						var final_ids = [];
						$.each(res, function (i, r) {
							r = r.replace('data-id="', '');
							r = r.replace('"', '');
							if (typeof o.options[r] === "undefined") {
								o.options.ids[r] = o.options.pages;
							}
						});
					}
					page_content += c;
				}
				return { page_content_test, html, page_content };
			},

            paginateSection: function(content, section) {
                const o = this;

                content = content.replaceAll('\n\n\n', '<br><br>');
                content = content.replaceAll('\n', '<br>');
                content = content.replaceAll("\r", '');
                content = content.replaceAll('<br><br><br>', '<br><br>');
                const heightTester = document.querySelector(".book_page.page_sampler .page_content .page_content_inner");
                heightTester.innerHTML = content;
                if (heightTester.offsetHeight > o.options.max_height) {
                    const desiredContentLengthMin = 300;
                    let remainingContent = '';
                    while (content.length > 0) {
                        let lastIdx = content.length;
                        let offset = 0;
                        remainingContent = '';
                        while(heightTester.offsetHeight > o.options.max_height) {
                            let htContent = heightTester.innerHTML;
                            const desiredContentLengthMax = htContent.length - 100;
                            const lastDblLfIdx = htContent.lastIndexOf('<br><br>', desiredContentLengthMax);
                            const lastLfIdx = htContent.lastIndexOf('<br>', desiredContentLengthMax);
                            const lastPeriodIdx = htContent.lastIndexOf('.', desiredContentLengthMax);
                            if (lastDblLfIdx !== -1 && lastDblLfIdx > desiredContentLengthMin){
                                lastIdx = lastDblLfIdx;
                                offset = 8;
                            } else if (lastLfIdx !== -1 && lastLfIdx > desiredContentLengthMin) {
                                lastIdx = lastLfIdx;
                                offset = 4;
                            } else if (lastPeriodIdx !== -1 && lastPeriodIdx > desiredContentLengthMin) {
                                lastIdx = lastPeriodIdx;
                                offset = 1;
                            } else {
                                let lastSpaceIdx = htContent.lastIndexOf(' ', desiredContentLengthMax);
                                if (lastSpaceIdx !== -1 && lastSpaceIdx > desiredContentLengthMin) {
                                    lastIdx = lastSpaceIdx;
                                } else {
                                    lastIdx = desiredContentLengthMax;
                                }
                            }
                            remainingContent = htContent.substring(lastIdx) + remainingContent;
                            heightTester.innerHTML = htContent.substring(0, lastIdx);
                        }
                        let calculatedContent = heightTester.innerHTML;
                        content = remainingContent;

                        const regex = /^(<br>)*/i;
                        calculatedContent = calculatedContent.replace(regex, '');
                        section.content.push(calculatedContent);
                        heightTester.innerHTML = content;
                    }
                    content = remainingContent
                } else {
                    section.content.push(content);
                }
                heightTester.innerHTML = '';
             },
            _getPageFooter: function(section){
				var o = this;
				var meta = o.options.bookMeta;
				var footer = '<div class="book_footer">';
				footer += '<span class="meta_separator"></span>';
				footer += '<div class="meta_sections">';
				footer += '<div class="meta_left">';
				footer += '<span class="meta_logo"><img src="/vetology_asset/images/flipbook/logo-pages.png" title="Vetology.net"/></span>';
				footer += '</div>';
				footer += '<div class="meta_center">';
				if((o.options.pages == parseFloat(o.options.pages) ? !(o.options.pages%2) : void 0) === false){
					footer += '<span class="meta_item meta_item_1">' + meta.clinic.type + ": " + meta.clinic.name + '</span>';
					footer += '<span class="meta_item meta_item_2">' + meta.clinic.address + '</span>';
					if(meta.clinic.email.length > 0){
						footer += '<span class="meta_item meta_item_3">Email: ' + meta.clinic.email + '</span>';
					}
				} else {
					footer += '<span class="meta_item meta_item_1">' + meta.clinic.type + ": " + meta.clinic.name + '</span>';
					var count = 2;
					if(meta.clinic.phone.length > 0){
						footer += '<span class="meta_item meta_item_' + count + '">Phone: ' + meta.clinic.phone + '</span>';
						count ++;
					}
					if(meta.clinic.fax.length > 0){
						footer += '<span class="meta_item meta_item_' + count + '">Fax ' + meta.clinic.fax + '</span>';
					}
				}
				footer += '</div>';
				footer += '<div class="meta_right">';
                if (typeof section === 'object' && typeof section.title !== 'undefined') {
                    footer += '<span class="meta_section">';
                    footer += section.title;
                    footer += '</span>';
                }
				footer += '<span class="meta_page">';
				footer += o.options.pages;
				footer += '</span>';
				footer += '</div>';
				footer += '</div>';
				footer += '</div>';
				return footer;
			},
			_getPageHeader: function(){
				var o = this;
				var meta = o.options.bookMeta;
				var header = '<div class="book_header">';
				header += '<span class="meta_separator"></span>';
				header += '<div class="meta_sections">';
				header += '<div class="meta_left">';
				if((o.options.pages == parseFloat(o.options.pages) ? !(o.options.pages%2) : void 0) === false){
					header += '<span class="meta_item meta_item_1">Patient: ' + meta.patient.name + '</span>';
					header += '<span class="meta_item meta_item_2">' + meta.patient.sex + '</span>';
					header += '</div>';
					header += '<div class="meta_center">';
					header += '<span class="meta_item meta_item_1">' + meta.patient.species;
                    const breed = meta.patient.breed.trim().toLowerCase();
                    if (breed.length > 0 && breed.indexOf('unknown') === -1 && breed.indexOf('(') === -1) {
                        header += " " + meta.patient.breed;
                    }
                    header += '</span>';
					header += '<span class="meta_item meta_item_2">DOB: ' + meta.patient.birth + '</span>';
					header += '</div>';
				} else {
					header += '<span class="meta_item meta_item_1">Guarantor: ' + meta.owner.name + '</span>';
					var count = 2;
					if(meta.owner.phones.length > 0){
						header += '<span class="meta_item meta_item_' + count + '">Phone' + (meta.owner.phones.length > 1 ? 's' : '') + ': ';
						header += meta.owner.phones.join(", ");
						header += '</span>';
						count ++;
					}
					if(meta.owner.cells.length > 0){
						header += '<span class="meta_item meta_item_' + count + '">Cell' + (meta.owner.cells.length > 1 ? 's' : '') + ': ';
						header += meta.owner.cells.join(", ");
						header += '</span>';
						count ++;
					}
					header += '<div class="meta_center">';
					count = 1;
					if(meta.owner.emails.length > 0){
						header += '<span class="meta_item meta_item_' + count + '">Email' + (meta.owner.emails.length > 1 ? 's' : '') + ': ';
						header += meta.owner.emails.join(", ");
						header += '</span>';
						count ++;
					}
					header += '</div>';
				}
				header += '</div>';
				header += '<div class="meta_right">';
				header += '<span class="meta_page">';
				header += o.options.pages;
				header += '</span>';
				header += '</div>';
				header += '</div>';
				header += '</div>';
				return header;
			},
			_numberOfViews: function(book){
				return book.turn('pages') / 2 + 1;
			},
			getViewNumber: function(book, page) {
				var o = this;
				return parseInt((page || book.turn('page'))/2 + 1, 10);
			},
			zoomHandle: function(e) {
				var o = this;
				if ($('.vetology_pages').data().zoomIn)
					o.zoomOut();
				else if (e.target && $(e.target).hasClass('zoom-this')){
					o.zoomThis($(e.target));
				}
			},
			zoomThis: function(pic) {
				var	position, translate,
				tmpContainer = $('<div />', {'class': 'zoom-pic'}),
				transitionEnd = $.cssTransitionEnd(),
				tmpPic = $('<img />'),
				zCenterX = $('.vetology_book_wrap_inner').width()/2,
				zCenterY = $('.vetology_book_wrap_inner').height()/2,
				bookPos = $('.vetology_book_wrap_inner').offset(),
				picPos = {
					left: pic.offset().left - bookPos.left,
					top: pic.offset().top - bookPos.top
				},
				completeTransition = function() {
				$('.vetology_book_wrap_inner').unbind(transitionEnd);
					if ($('.vetology_pages').data().zoomIn) {
						tmpContainer.appendTo($('body'));
						$('body').css({'overflow': 'hidden'});
						tmpPic.css({
							margin: position.top + 'px ' + position.left+'px'
						}).
						appendTo(tmpContainer).
						fadeOut(0).
						fadeIn(500);
					}
				};
				$('.vetology_pages').data().zoomIn = true;
				$('.vetology_pages').turn('disable', true);
				$(window).resize(zoomOut);
				tmpContainer.click(zoomOut);
				tmpPic.load(function() {
					var realWidth = $(this)[0].width,
					realHeight = $(this)[0].height,
					zoomFactor = realWidth/pic.width(),
					picPosition = {
						top:  (picPos.top - zCenterY)*zoomFactor + zCenterY + bookPos.top,
						left: (picPos.left - zCenterX)*zoomFactor + zCenterX + bookPos.left
					};
					position = {
						top: ($(window).height()-realHeight)/2,
						left: ($(window).width()-realWidth)/2
					};
					translate = {
						top: position.top-picPosition.top,
						left: position.left-picPosition.left
					};
					$('.samples .bar').css({visibility: 'hidden'});
					$('#slider-bar').hide();
					$('.vetology_book_wrap_inner').transform(
						'translate('+translate.left+'px, '+translate.top+'px)' +
						'scale('+zoomFactor+', '+zoomFactor+')'
					);
					if (transitionEnd)
						$('.vetology_book_wrap_inner').bind(transitionEnd, completeTransition);
					else
						setTimeout(completeTransition, 1000);
				});
				tmpPic.attr('src', pic.attr('src'));
			},
			zoomOut: function() {
				var transitionEnd = $.cssTransitionEnd(),
				completeTransition = function(e) {
					$('.vetology_book_wrap_inner').unbind(transitionEnd);
					$('.vetology_pages').turn('disable', false);
					$('body').css({'overflow': 'auto'});
					moveBar(false);
				};
				$('.vetology_pages').data().zoomIn = false;
				$(window).unbind('resize', zoomOut);
				moveBar(true);
				$('.zoom-pic').remove();
				$('.vetology_book_wrap_inner').transform('scale(1, 1)');
				$('.samples .bar').css({visibility: 'visible'});
				$('#slider-bar').show();
				if (transitionEnd)
					$('.vetology_book_wrap_inner').bind(transitionEnd, completeTransition);
				else
					setTimeout(completeTransition, 1000);
			},
			moveBar: function(yes) {
				if (Modernizr && Modernizr.csstransforms) {
					$('#slider .ui-slider-handle').css({zIndex: yes ? -1 : 10000});
				}
			},
			setPreview: function(view) {
				var previewWidth = 115,
				previewHeight = 73,
				previewSrc = 'pages/preview.jpg',
				preview = $(_thumbPreview.children(':first')),
				numPages = (view==1 || view==$('#slider').slider('option', 'max')) ? 1 : 2,
				width = (numPages==1) ? previewWidth/2 : previewWidth;
				_thumbPreview.
				addClass('no-transition').
				css({
					width: width + 15,
					height: previewHeight + 15,
					top: -previewHeight - 30,
					left: ($($('#slider').children(':first')).width() - width - 15)/2
				});
				preview.css({
					width: width,
					height: previewHeight
				});
				if (preview.css('background-image')==='' ||
				preview.css('background-image')=='none'){
					preview.css({backgroundImage: 'url(' + previewSrc + ')'});
					setTimeout(function(){
						_thumbPreview.removeClass('no-transition');
					}, 0);
				}
				preview.css({
					backgroundPosition: '0px -'+((view-1)*previewHeight)+'px'
				});
			},
			isChrome: function(){
				return navigator.userAgent.indexOf('Chrome')!=-1;
			},
			_initCharts: function(){
				var o = this;
				google.charts.load('current', {'packages':['bar','annotationchart']});
			},
			_updateChart: function(el){
				var o = this;
				if(typeof o.options.charto != "undefined"){
					o.options.charto.clearChart();
				}
				var name = el.val();
				if(name == ""){
					return;
				}
				var type = $(".graph_type").val();
				var graph = o.options.graph[name];
				var values = [];
				switch(type){
					case "AnnotationChart":
						var data = new google.visualization.DataTable();
						data.addColumn('number', 'Result');
						data.addColumn('string', 'Date');
						$.each(graph.values, function(date, value){
							date = date.split('-');
							var a = [
								new Date(date),
								parseFloat(graph.low),
								parseFloat(graph.high),
								parseFloat(value),
							];
							values.unshift(a);
						});
						$.each(values, function(i, v){
							data.addRow(v);
						});
						el = $(".graph_canvas").find(".canvas")[0];
						var chart = new google.visualization.AnnotationChart(el);
						var options = {
							displayAnnotations: true
						};
						chart.draw(data, options);
					break;
					case "Bar":
						var data = [
							[
								'Date',
								'Low',
								'Value',
								'High',
							]
						];
						$.each(graph.values, function(date, value){
							var a = [
								date,
								parseFloat(graph.low),
								parseFloat(value),
								parseFloat(graph.high),
							];
							values.unshift(a);
						});
						$.each(values, function(i, v){
							data.push(v);
						});
						var options = {
							title : 'Historical values of ' + name,
							vAxis: {title: 'Reference'},
							hAxis: {title: 'Date'},
							seriesType: 'bars'
						};
						var data = google.visualization.arrayToDataTable(data);
						el = $(".graph_canvas").find(".canvas")[0];
						var chart = new google.charts.Bar(el);
						chart.draw(data, google.charts.Bar.convertOptions(options));
					break;
					case "AreaChart":
						var data = [
							[
								'Date',
								'Low',
								'Value',
								'High',
							]
						];
						$.each(graph.values, function(date, value){
							var a = [
								date,
								parseFloat(graph.low),
								parseFloat(value),
								parseFloat(graph.high),
							];
							values.unshift(a);
						});
						$.each(values, function(i, v){
							data.push(v);
						});
						var options = {
							title : 'Historical values of ' + name,
							vAxis: {title: 'Reference'},
							hAxis: {title: 'Date'},
							seriesType: 'bars',
							series: {1: {type: 'line'}}
						};
						var data = google.visualization.arrayToDataTable(data);
						el = $(".graph_canvas").find(".canvas")[0];
						var chart = new google.visualization.AreaChart(el);
						chart.draw(data, options);
					break;
				}
				o.options.charto = chart;
			},
			_initEvents: function(){
				var o = this;
				var f = $(".vetology_pages");
				$("body").on("change", ".graph_type, .graph_changer", function(e){
					o._updateChart($(".graph_changer"));
				});
				$("body").on("click", ".flipbook_print", function(e){
					$("body").addClass("print_preview");
					o._loadPrintBook();
                    let menuItem = e.target;
                    if (menuItem.nodeName === 'SPAN') {
                        menuItem = menuItem.closest('a.flipbook_print');
                    }
                    const parentMenuItem = menuItem.nextSibling;
                    if (parentMenuItem && parentMenuItem.style.display === 'none') {
                        parentMenuItem.style.display = 'block';
                    }

				});
				$("body").on("click", ".return_to_flipbook", event => {
					$("body").removeClass("print_preview");
                    let menuItem = event.target;
                    const parentMenuItem = menuItem.closest('ul.treeview-menu');
                    parentMenuItem.style.display = 'none';
				});
				$("body").on("click", ".bar_chart, .plot_chart, .amie_trigger, .lab_test_desc", function(e){
					var el = $(this);
					var test = el.data("test");
					switch(true){
						case el.hasClass("lab_test_desc"):
							$("body").Vetology("vetologyShowDialog", test + " description", o.options.lab_descriptions[test], "info");
						break;
						case el.hasClass("bar_chart"):
							var test = $(this).data("test");
							f.turn("page", o.options.ids["panels_graph"]);
							setTimeout(
								function(){
									$(".graph_changer").val(test).change();
								}, 300
							);
						break;
						case el.hasClass("plot_chart"):
							var test = $(this).data("test");
							f.turn("page", o.options.ids["panels_graph_map"]);
							o.broadcastTurn(e, f.turn("page"));
							setTimeout(
								function(){
									$(".graph_changer").val(test).change();
								}, 300
							);
						break;
					}
				});
				$("body").on("click", ".flipbook_page", function(e){
					var page = $(this).data("page");
					f.turn("page", page);
					o.broadcastTurn(e, f.turn('page'));
				});
				$("body").on("click", ".flipbook_page_finder", function(e){
					var el = $(this);
					f.turn("page", o.options.ids[el.data("id")]);
				});
				$("body").on("click", ".to_local_print", function(e){
					window.print();
				});
				$("body").on("click", ".print_to_pdf", event => {
                    const o = this;
					event.preventDefault();
					var el = event.target;
					$(el).html("Please wait...");
					var html = $(".book_printer").html();
                    o._ajax(
                            'POST',
                            {
                                html: html,
                                first_name: o.options.patient.first_name,
                                last_name: o.options.patient.last_name,
                                dos: o.options.patient.birth_date
                            },
                            // '/patient/detailnew/?did=_1526503&print=1',
                            window.location.href,
                            function(json){
                                $(el).html("Get PDF");
                                if(json.link != false){
                                    $("body").off("click", ".print_to_pdf");
                                    const parentElement = el.parentElement;
                                    el.remove();
                                    const newEl = document.createElement('a');
                                    newEl.setAttribute('href', json.link);
                                    newEl.setAttribute('target', '_blank');
                                    newEl.textContent = 'Get PDF';
                                    parentElement.append(newEl);
                                    window.open(json.link, "_blank");
                                } else {
                                    alert('There was an error generating your PDF, please try again later.');
                                }
                            },
                            'json',
                            null
                    );
				});
				$("body").on("click", ".toggle_page_visibility", function(e){
					e.preventDefault();
					var el = $(this).toggleClass('vetology-view').toggleClass('vetology-hide').closest(".print_wrap").toggleClass('no_print');
				});
				$("body").on("click", ".print_book_enable", function(e){
					e.preventDefault();
					$(".book_printer").removeClass("hide");
					$("body").attr("style", "overflow: scroll !important;");
					var el = $(this);
					el.find(".vetology-loop").addClass("spinPrint");
					var url = "&print=1";
					setTimeout(
						function(){
							o._loadHTML(true);
						},
						300
					);
				});
				$("body").on("click", ".print_book_disable", function(e){
					e.preventDefault();
					$("body").attr("style", "");
					$(".print_selector").addClass("hide");
				});
				$("body").on("change", ".cb_printer", function(e){
					var url = "&print=1";
					$(".cb_printer:checked").each(function(i, cb){
						url += "&" + $(cb).attr("name") + "=" + $(cb).val();
					});
					$("a.print_book_now").attr("href", url);
				});
				var item = $(".vetology_book_wrap")[0];
				$("body").on("click", ".flipbook_control", function(){
					var el = $(this);
					switch(el.data("action")){
						case "flip":
							f.turn(el.data("flip"));
						break;
						case "fullscreen":
							Turn.toggleFullScreen();
						break;
					}
				});
				$("body").on(Turn.isTouchDevice ? "doubletap" : "tap", ".vetology_pages", function(event){
					if (!(event.currentTarget.classList.contains('last-page') && !event.target.classList.contains('vetology-left'))) {
						f.turn('toggleZoom', {pageX: event.pageX, pageY: event.pageY, animate: true});
						o.broadcastTurn(event, f.turn('page'));
                    }
				});
				$("body").on("keydown", function(event){
					var nextArrow = 39, prevArrow = 37;
					if (event.keyCode==prevArrow) {
						f.turn("previous");
					} else if (event.keyCode==nextArrow) {
						f.turn("next");
					}
					o.broadcastTurn(event, f.turn('page'));
				});
				// Fix: Corner clicks fail after window loses/regains focus.
				// Browsers dispatch a spurious mousemove when regaining focus,
				// which changes turn.js internal status from "tapping" to "move",
				// causing corner clicks to fold back instead of turning the page.
				// This blocks that spurious mousemove from reaching turn.js by
				// suppressing mousemove events briefly after the window regains focus.
				(function() {
					var suppressMouseMove = false;
					var suppressTimer = null;
					window.addEventListener('focus', function() {
						suppressMouseMove = true;
						clearTimeout(suppressTimer);
						suppressTimer = setTimeout(function() {
							suppressMouseMove = false;
						}, 150);
					});
					f[0].addEventListener('mousemove', function(e) {
						if (suppressMouseMove) {
							e.stopImmediatePropagation();
							e.preventDefault();
						}
					}, true);
				})();
				$(window).resize(function(){
					clearTimeout(window.flipResizeTrigger);
					window.flipResizeTrigger = setTimeout(function(){
						o.options.width = $(window).width();
						o.options.height = $(window).height();
						o._loadHTML();
						o.options.init = true;
                        o._setBookSize();
					}, 500);
				});
			},
			windowResized: function(){
				var o = this;
				clearTimeout(o.options.flipResizeTrigger);
				window.flipResizeTrigger = setTimeout(function(){
					o.options.o.options.width = $(window).width();
					o.options.o.options.height = $(window).height();
					o.o._loadHTML();
					o.options.o.options.init = true;
				}, 500);
			},
			_loadPrintBook: function(){
				var o = this;
				var m = moment();
				var title = o.options.bookMeta.patient.name + ' :: Vetology Flipbook :: @' + m.format('MMMM Do YYYY');;
				if(o.options.print_ready){
					return;
				}
				var text = 'Preparing layout:<br>Please wait while I prepare the<br>' + title + '<br><span class="vetology-fax" style="font-size: 80px;"></span>';
				$("body").Vetology("vetologyLoadStart", text, text, true);
				setTimeout(
					function(){
						var display = o._setBookSize();
						var book = o.options.book;
						var canvas = $(".book_printer");
						o.options.pages = 0;
						$.each(o.options.sections, function(i, s){
							if(s.content.length > 0 || s.is_table){
								o._setBookPrintPages(s.content, s);
							}
						});
						o.options.print_ready = true;
						if(canvas.find(".book_page").length > 0 && canvas.find(".book_page").last().find(".page_content_inner").html() === ""){
							canvas.find(".book_page").last().remove();
						}
						$("body").Vetology("vetologyLoadEnd");
						document.title = title;
					}, 50
				);
			},
			_loadBook: function(){
				var o = this;
				var display = o._setBookSize();
				var book = o.options.book;
				var canvas = $(".vetology_pages");
				var page = 1;
				/*Front cover*/
				var page = '<div depth="5" class="book_cover cover_1">';
				page += '<div class="side"></div>';
				page += '<div class="page_content">';
				page += '<div class="vetology_logo">';
                console.log(book.meta.clinic);
 				page += '<img src="/vetology_asset/images/flipbook/cover-front-logo.png" title="Vetology.net"/>';
				page += '</div>';
				page += '<div class="clinic_logo">';
                if (typeof o.options.facility.customLogo === 'object') {
                    const customLogo = o.options.facility.customLogo;
                    page += '<div class="custom-logo-markup ' + customLogo.class + '">';
                    page += customLogo.html;
                    page += '</div>';
                } else if (!o.options.facility.hasLogo && o.options.facility.can_upload_logo) {
                    page += '<div id="add-clinic-logo">';
                        page += '<a class="upload-logo" href="javascript:void(0)">Click to add clinic logo</a>';
                        page += '<input id="upload-logo" type="file" accept="image/png, image/jpeg, image/bmp" name="clinic_logo" />';
                        page += '<input type="hidden" name="clinic_id" value="' + o.options.facility.clinicID + '">';
                        page += '<input type="hidden" name="token" value="' + o.options.facility.token + '">';
                        page += '</div>';
                }
				page += '<img class="clinic-logo" title="' + book.meta.clinic.name + '" src="/download/' + book.front_cover.clinic_logo + '">';
				page += '</div>';
				page += '<div class="patient_presentation">';
				page += '<img title="' + book.meta.patient.name + '" src="/download/' + book.front_cover.patient_thumbnail + '?tn=0">';
				page += '<span>' + book.meta.patient.name + '</span>';
				page += '</div>';
				page += '</div>';
				canvas.append(page);
                o._setBookPrintPages([page]);
				o.options.pages = 2;
				/*Front cover behind*/
				if(display === "double"){
					page = '<div depth="5" class="book_cover cover_2">';
					page += '<div class="depth"></div><div class="page_content"></div>';
					page += '</div>';
					canvas.append(page);
					o.options.pages ++;
					page = o._getBookPages([]);
					canvas.append(page);
				}
				var tabs = {};
				$.each(o.options.sections, function(i, s){
					console.log(s.content.length, s);
					if(s.content.length > 0 || s.is_table){
						var tab = {
							from: o.options.pages,
							title: s.title,
							id: s.identifier,
							icon: s.icon
						};
						page = o._getBookPages(['<h2 class="section_title">' + s.title + '<br><i class="vetology-' + s.icon + '"></i></h2>'], display === "double");
						canvas.append(page);
						page = o._getBookPages(s.content, s);
						canvas.append(page);
						tab.to = o.options.pages;
						tabs["page-" + o.options.pages] = tab;
						if(display === "double" && o.options.pages % 2 !== 0){
							page = o._getBookPages([]);
							canvas.append(page);
						}
					}
				});
                let keys = Object.keys(tabs);
				$.each(tabs, function(i, tab){
                    let nextIndex = keys.indexOf(i) + 1;
                    if (nextIndex <= keys.length - 1) {
                        let nextItem = keys[nextIndex];
                        if (nextItem) {
                            tab.to = tabs[nextItem].from - 1;
                        }
                    }
                    // check if tab.to is too large
                    if (i < tabs.length && tab.to >= tabs[i+1].from ) {
                        tab.to = tabs[i+1].from - 1;
                    }
					var html = '<li class="treeview">';
					html += '<a href="#" class="vetology_pd flipbook_page" data-page="' + tab.from + '"><i class="vetology-' + tab.icon + '"></i> <span>' + tab.title + '<span><span class="index_info">(' + tab.from + '-' + tab.to + ')</span></a>';
					html += '<ul class="treeview-menu section_' + tab.id + '"></ul>';
					html += '</li>';
					$(".sidebar-menu").append(html);
				});
				var html = '<li class="treeview">';
				html += '<a href="#" class="vetology_pd flipbook_print"><i class="vetology-fax"></i> <span>Print<span></a>';
				html += '<ul class="treeview-menu">';
				html += '<li><a href="#" class="vetology_pd to_local_print">Send to local printer</a></li>';
				html += '<li><a href="#" class="vetology_pd print_to_pdf">Get PDF</a></li>';
                html += '<li><a href="#" class="vetology-send-pdf">Send PDF</a></li>';
				html += '<li><a href="#" class="vetology_pd return_to_flipbook">Return to book</a></li>';
				html += '</ul>';
				html += '</li>';
				$(".sidebar-menu").append(html);
				if(display === "double"){
					if(o.options.pages % 2 === 0){
						page = o._getBookPages([]);
						canvas.append(page);
					}
					/*Back cover behind*/
					page = '<div class="book_cover cover_3">';
					page += '<div class="page_content"></div>';
					page += '<div class="depth"></div>';
					page += '</div>';
					canvas.append(page);
					o.options.pages ++;
				}
				/*Back cover*/
				page = '<div class="book_cover cover_4">';
				page += '<div class="page_content">';
				page += '<div class="vetology_logo">';
				page += '<img src="/vetology_asset/images/flipbook/cover-back-logo.png" title="Vetology.net"/>';
				page += '</div>';
				page += '</div>';
				page += '</div>';
				canvas.append(page);
				o.options.pages ++;
				var display = o._setBookSize();
				canvas.bind(($.isTouch) ? 'touchend' : 'click', o.zoomHandle);
				var book_settings = {
					responsive: true,
					animatedAutoCenter: true,
					smartFlip: true,
					autoScaleContent: true,
					swipe: true,
					pageWidth: o.options.width,
					pageHeight: o.options.height,
					pages: o.options.pages,
					hover: true,
					acceleration: true,
					autoCenter: true,
					autoScroll: true,
					fragments: false,
					hoverAreaSize: 50,
					cornerPosition: "50px 20px",
					margin: "0px 0px",
					pageMargin: "0px 0px",
					elevation: "10%",
					ignoreElements: "[ignore=1]",
					gradients: true,
					turnCorners: "l,r",
					events: null,
					showDoublePage: false,
					zoomAnimationDuration: 1e4,
					when: {
						turned: function(){
                            const docsUploader = document.querySelector('div.docs_uploader.flipbook_docs');
                            if (docsUploader && docsUploader.childNodes.length === 0) {
                                $(".docs_uploader").FileUpload();
                            }
						}
					}
				};
				canvas.turn(book_settings);
				$.each(o.options.ids, function(id, page){
					var def = o.options.def[id];
					if(typeof def == "undefined"){
						console.log(id);
						console.log(o.options.def);
					} else {
						var ul = $(".section_" + def.section);
						ul.append('<li><a href="#" class="vetology_pd flipbook_page" data-page="' + page + '">' + def.text + '<span class="index_info">' + page + '</span></a></li>');
					}
				});
				o.options.tabs = tabs;
			},
			_loadHTML: function(print){
				var o = this;
				var book = {
					meta: o.options.bookMeta,
					sections: []
				}, section;
				book.front_cover = {
					clinic_logo: o.options.facility.logo,
					patient_thumbnail: o.options.thumb
				};
				book.blank_page_after_cover = true;
				book.blank_page_after_each_section = true;
				book.add_footer = true;
				book.add_header = true;
				/*
				is_cover =
					0: front cover
					1: front cover behind
					2: back cover behind
					3: back cover
					4: false, is not a cover page
				*/
				o.options.book = book;
			},
            _ajax	: function(method, data, url, done, type, notAfterAjax){
                var o = this;
                // o._loading(true);
                if(o.options.doingAjax){
                    console.warn('An ajax call is running at this time, please wait.');
                    return;
                }
                o.options.doingAjax = true;
                $.ajax(
                    {
                        url			: url,
                        method		: method,
                        data		: data,
                        dataType	: type,
                        statusCode	: {
                            404: function(e) {
                                $("body").Vetology("vetologyShowDialog", "The item you are attempting to access does not exist.", "info");
                            },
                            403: function() {
                                $("body").Vetology("vetologyShowDialog", "The item you are attempting to access does not exist.", "info");
                            },
                            500: function() {
                                $("body").Vetology("vetologyShowDialog", "Token mismatch, Your session has expired please refresh the page and try again.", "info");
                            },
                            401: function() {
                                $("body").Vetology("vetologyShowDialog", "Unauthorized, token mismatch, please refresh the page.", "info");
                            },
                            405: function() {
                                $("body").Vetology("vetologyShowDialog", "The item you are attempting to access does not exist.", "info");
                            }
                        },
                        error		: function(a, b){
                            $("body").Vetology("vetologyShowDialog", "There was an unknown error, please check the log.", "info");
                            o.options.doingAjax = false;
                        },
                        success		: function(response){
                            $.when(done(response)).then(function() {
                                o.options.doingAjax = false;
                                $(window).resize();
                                if(typeof notAfterAjax !== 'undefined' && typeof processAfterAjax !== 'undefined'){
                                    processAfterAjax();
                                }
                            });
                        }
                    }
                );
            },
            onSendPdfClick: function(event) {
                const _self = this;
                $('div.send-pdf-modal').modal();
            },
            sendPDF: function(event) {
                const _self = this;
                const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                const sendPdfBtn = event.target; 
                const emailInput = sendPdfBtn.closest('.modal-content').querySelector('#email-recipient-input');
                const emailRecipient = emailInput.value;
                if (!emailRecipient.match(emailRegex)) {
                    toastr.error('Please enter a valid email address');
                    return;
                }
                const sendPdfModal = document.querySelector('div.send-pdf-modal');
                const $sendPdfModal = $(sendPdfModal);
                $sendPdfModal.modal('hide');

                const bookPrinter = document.querySelector('.book_printer');
                const html = bookPrinter.innerHTML;
                const formData = new FormData();
                formData.append('html', html);
                formData.append('first_name', _self.options.patient.first_name);
                formData.append('last_name', _self.options.patient.last_name);
                formData.append('dos', _self.options.patient.birth_date);
                formData.append('email_recipient', emailRecipient);
                formData.append('case_id', document.body.dataset.case_id);

                fetch(window.location.href, {
                    method: 'post',
                    body: formData,
                    headers: {
                        'Accept': 'application/json'
                    }
                }).then(response => {
                    if (response.ok) {
                        const contentType = response.headers.get("content-type");
                        if (contentType && contentType.indexOf('application/json') !== -1) {
                            return response.json().then(json => {
                                if (json.success) {
                                    toastr.success('We have successfully sent the pdf to the specified recipient');
                                } else {
                                    toastr.error(json.errorMsg);
                                }
                            });
                        } else {
                            toastr.error('We are unable to process your request at this time.  Please call support.')
                        }
                    } else {
                        toastr.error('We are unable to send the PDF at this time.');
                        return false;
                    }
                });

            },
			broadcastTurn: function (event, page) {
				const evt = new CustomEvent('page-turn-event',
					{
						detail: {
							originalEvent: event,
							page: page,
						 }
					});
				setTimeout(() => {
					document.dispatchEvent(evt);
				}, 500);

			},
            onAddClinicLogo: function(event) {
                event.preventDefault();
                event.stopPropagation();

                const logoInput = document.querySelector('input#upload-logo')
                const clickEvent = new MouseEvent('click')
                logoInput.dispatchEvent(clickEvent)
                logoInput.addEventListener('change', (event) => {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    const logoContainer = document.querySelector('div.clinic_logo');
                    const clinicIdElem = logoContainer.querySelector('input[name="clinic_id"]');
                    const tokenElem = logoContainer.querySelector('input[name="token"]');
                    const imagePath = logoInput.value;

                    const formData = new FormData();
                    formData.append('logo', logoInput.files[0]);
                    formData.append('clinicID', clinicIdElem.value);
                    formData.append('_token', tokenElem.value);
                    fetch('/flipbook/upload-logo', {
                        method: 'post',
                        body: formData,
                        headers: {
                            accept: 'application/json'
                        }
                    }).then(response => {
                       if (response.ok) {
                            response.json().then(json => {
                                toastr.success('successfully upoaded logo');
                                const logoContainer = event.target.closest('.clinic_logo');
                                const imgElem = logoContainer.querySelector('img')
                                imgElem.setAttribute('src', '/download/' + json.logo);
                                const addLogoContainer = logoContainer.querySelector('#add-clinic-logo');
                                addLogoContainer.remove();
                            });
                       } else {
                           toastr.error('Error saving logo.  Please try later');
                       }
                    });
                })
            }

        }
	);
})(jQuery);


